<template>
    <relatorio-page titulo="Relação de Recebíveis" :cabecalhoCompleto="true" :exportarExcel="false" :paisagem="true">
        <v-simple-table id="tabela" dense class="py-2 text-caption fonte">
            <template v-slot:default>
                <thead style="background-color: #4A70A8">
                    <tr>
                        <th style="font-size: 100% ; color: white " class="text-left fonte">Cód.</th>
                        <th style="font-size: 100% ; color: white ; width: 250px" class="text-center fonte">Doador</th>
                        <th style="font-size: 100% ; color: white " class="text-center fonte">Sit.</th>
                        <th style="font-size: 100% ; color: white " class="text-center fonte">Vencimento</th>
                        <th style="font-size: 100% ; color: white " class="text-center fonte">Pagamento</th>
                        <th style="font-size: 100% ; color: white " class="text-center fonte">Desconto</th>
                        <th style="font-size: 100% ; color: white " class="text-center fonte">Juros</th>
                        <th style="font-size: 100% ; color: white " class="text-center fonte">Total</th>
                        <th style="font-size: 100% ; color: white " class="text-center fonte">Projeto</th>
                        <th style="font-size: 100% ; color: white " class="text-center fonte">Forma Pgt.</th>
                        <th style="font-size: 100% ; color: white ; width: 300px" class="text-center fonte">Descrição</th>
                    </tr>
                </thead>
                <tbody class="fonte">
                    <tr v-for="(item, index) in item.recebiveis" :key="index" :style=" index % 2 === 0 ? 'background-color: gainsboro' : 'background-color: White'">
                        <td style="font-size: 100% " class="text-left">{{ item.codigo }}</td>
                        <td style="font-size: 100% ; width: 250px" class="text-center">{{ item.doador }}</td>
                        <td style="font-size: 100% " class="text-center">{{ item.situacao }}</td>
                        <td style="font-size: 100% " class="text-center">{{ new Date(item.dataVencimento).ddmmyyyy() }}</td>
                        <td style="font-size: 100% " class="text-center">{{ item.dataPagamento ? new Date(item.dataPagamento).ddmmyyyy() : '' }}</td>
                        <td style="font-size: 100% " class="text-center">{{ item.desconto.toMoeda() }}</td>
                        <td style="font-size: 100% " class="text-center">{{ item.juros.toMoeda() }}</td>
                        <td style="font-size: 100% " class="text-center">{{ item.valorFinal.toMoeda() }}</td>
                        <td style="font-size: 100% " class="text-center">{{ item.projeto }}</td>
                        <td style="font-size: 100% " class="text-center">{{item.formaPagamento}}</td>
                        <td style="font-size: 100% ; width: 300px" class="text-right">{{item.descricao}}</td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <td colspan="10">
                            <v-row>
                                <v-col cols="12" md="4">
                                    <b>Total Desconto: {{ item.totalDesconto.toMoeda(true) }}</b>
                                </v-col>
                                <v-col cols="12" md="4" class="text-center">
                                    <b>Total Juros: {{ item.totalJuros.toMoeda(true) }}</b>
                                </v-col>
                                <v-col cols="12" md="4" class="text-right">
                                    <b>Total Recebíveis: {{ item.total.toMoeda(true) }}</b>
                                </v-col>
                            </v-row>
                        </td>
                    </tr>
                </tfoot>
            </template>
        </v-simple-table>

        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

    </relatorio-page>
</template>

<script>
import RecebivelService from '@/core/services/financeiro/RecebivelService';

export default {
    data(){
        return {
            overlay: false,
            empresa: {},
            item: {
                recebiveis: [],
                totalDesconto: 0,
                totalJuros: 0,
                total: 0
            },
            
        }
    },
    mounted(){
        
        this.sessionApp = JSON.parse(localStorage.sessionApp);
        this.empresa = {
            nomeCnpj: this.sessionApp.empresaNomeCnpj
        };

        this.overlay = true;
        let filter = this.$route.query;
        let recebivelService = new RecebivelService();

        recebivelService.Relatorio(filter.doadorId, filter.projetoId, filter.vencimentoInicial, filter.vencimentoFinal, filter.pagamentoInicial, filter.pagamentoFinal, 
            filter.emissaoInicial, filter.emissaoFinal, filter.competenciaInicial, filter.competenciaFinal, filter.formaPagamentoId, filter.bancoId, filter.pessoalId, filter.regiaoId, filter.situacao, filter.codigoInicial, filter.codigoFinal).then(
            res => {
                this.item = res.data;
            },
            err => {
                this.$swal('Aviso', err.message, 'error');
            }
        )
        .finally(() => {
            this.overlay = false;
        });
    },
    methods: {
        Imprimir(){
            window.print();
        },
        Fechar(){
            window.close();
        }
    }
}

</script>

<style>
    .fonte{
        font-size: 90%;
    }
</style>